module.exports = __webpack_public_path__ + "img/Reading_5.21be24db.svg";